import { type Writable, writable } from 'svelte/store';

interface Card {
  memberId: string;
  group: string;
  bin: string;
  pcn: string;
  type: 'people' | 'pets';
}

interface CardData {
  card: Card;
  smsEndpoint: string;
  emailEndpoint: string;
}

const card: Writable<CardData | null> = writable(null);

export default card;
